import { Node, useReactFlow } from '@xyflow/react';
import { memo } from 'react';

import ConditionalForm from './ConditionalForm';
import GroupManageContactForm from './GroupManageContactForm';

import {
  BinaryConditionalData,
  GroupsManageContactData,
} from '@/modules/AutomationModuleNew/types/flowsTypes';

interface SidePanelContentProps {
  nodeId: string;
}

const SidePanelContent = ({ nodeId }: SidePanelContentProps) => {
  const { getNode } = useReactFlow();
  if (!nodeId) return null;
  const node = getNode(nodeId);

  if (node?.data.type === 'groupsManageContact') {
    const nodeData: Node<GroupsManageContactData> = node as Node<GroupsManageContactData>;
    return <GroupManageContactForm {...nodeData} />;
  }
  if (node?.data.type === 'binaryConditional') {
    const nodeData: Node<BinaryConditionalData> = node as Node<BinaryConditionalData>;
    return <ConditionalForm {...nodeData} />;
  }

  return null;
};

export default memo(SidePanelContent);
